import React from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ActivityCard = ({ activity }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/activities/details/", { state: activity });
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        height: 500, // Increased height for larger card
        borderRadius: "20px", // Maintain sleek, rounded look
        backgroundColor: "#1C2A39",
        overflow: "hidden",
        boxShadow: "0 12px 50px rgba(0, 0, 0, 0.1)", // Slightly stronger shadow for depth
        transition: "transform 0.4s ease, box-shadow 0.4s ease",
        "&:hover": {
          transform: "translateY(-10px)", // More pronounced lift effect
          boxShadow: "0 20px 60px rgba(0, 123, 255, 0.3)", // More shadow on hover
        },
      }}
    >
      {/* Image Section */}
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          height: 320, // Taller image section
        }}
      >
        <CardMedia
          component="img"
          image={activity.image}
          alt={activity.title}
          sx={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
            transition: "transform 0.4s ease, filter 0.4s ease",
            "&:hover": {
              transform: "scale(1.1)", // Slightly larger zoom on hover
              filter: "brightness(1.15)", // Brighten on hover
            },
          }}
        />
      </Box>

      {/* Content Section */}
      <CardContent
        sx={{
          padding: "24px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* Title and Description */}
        <Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: "1.6rem", // Slightly larger title
              color: "#FFFFFF",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden", // Truncate long titles
              marginBottom: "12px",
            }}
          >
            {activity.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#D1D5DB",
              lineHeight: 1.7,
              display: "-webkit-box",
              WebkitLineClamp: 3, // Limit to 3 lines of description
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginBottom: "16px",
            }}
          >
            {activity.description}
          </Typography>
        </Box>

        {/* Action Button */}
        <Box>
          <Button
            variant="outlined"
            onClick={handleClick}
            sx={{
              padding: "12px 28px",
              color: "#007BFF",
              borderColor: "#007BFF",
              borderRadius: "50px", // Rounded button for modern look
              fontSize: "0.9rem",
              fontWeight: 600,
              textTransform: "uppercase",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              "&:hover": {
                backgroundColor: "#10a7e0",
                color: "#FFFFFF",
                boxShadow: "0 8px 20px rgba(0, 123, 255, 0.3)",
                transform: "translateY(-3px)", // Slight lift on hover
              },
            }}
          >
            View Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ActivityCard;
